import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-view" }
const _hoisted_2 = { class: "pa-6 bar ma-auto" }
const _hoisted_3 = { class: "mb-2 token-text-h4" }
const _hoisted_4 = { class: "mb-4" }

import { computed } from 'vue'

import getEnv from '@/utils/env'
import { clearAuthenticationRedirect, redirectToLogin } from '@/utils/authentication'
import CustomButton from '@/components/UIElements/CustomButton.vue';
import BackgroundGradiant from '@/components/UIElements/BackgroundGradiant.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthenticationErrorView',
  props: {
    status: {},
    reason: {}
  },
  setup(__props: any) {

const props = __props

const requiresVerification = computed(() => props.reason === 'identity-email-not-verified')
const title = computed(() => props.status === '403' ? 'Access denied' : 'Unable to load your account')
const message = computed(() => {
  if (requiresVerification.value) {
    return 'Your session is valid, but your email address must be verified before you can continue.'
  }

  if (props.status === '403') {
    return 'Your session is valid, but you do not have access to this application.'
  }

  return 'The application could not load your account. Please try again later.'
})
const verificationUrl = computed(() => {
  const portal = getEnv('VUE_APP_AUTH_PORTAL_URL')
  const url = new URL('/verify', `${portal.replace(/\/$/, '')}/`)
  url.searchParams.set('returnTo', new URL('/projects', window.location.origin).toString())

  return url.toString()
})

function verifyAgain(): void {
  window.location.href = verificationUrl.value
}

function signInAgain(): void {
  clearAuthenticationRedirect()
  redirectToLogin(new URL('/projects', window.location.origin).toString())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BackgroundGradiant),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(message.value), 1),
      (requiresVerification.value)
        ? (_openBlock(), _createBlock(CustomButton, {
            key: 0,
            class: "mx-auto",
            level: _ctx.$enums.ButtonLevels.Primary,
            onClick: verifyAgain,
            text: "Verify email address"
          }, null, 8, ["level"]))
        : (_openBlock(), _createBlock(CustomButton, {
            key: 1,
            class: "mx-auto",
            level: _ctx.$enums.ButtonLevels.Primary,
            onClick: signInAgain,
            text: "Sign in again"
          }, null, 8, ["level"]))
    ])
  ]))
}
}

})